import { ApiEndpoints } from "../core";
import { httpClient } from "../core";
import {
  addExerciseState,
  updateBiometricExercise,
  changeExerciseLoading,
  deleteExerciseState,
  dispatch,
  setErrorMessage,
  setExerciseState,
  setSuccessMessage,
  updateExerciseState,
} from "../redux";

export const getExercise = async (
  refresh = false,
  page,
  limit,
  search = "",
  sort
) => {
  try {
    // Set Loading if it is not refresh
    if (!refresh) dispatch(changeExerciseLoading(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.getExercises, {
      params: {
        page,
        limit,
        // name: search,
        // sort,
      },
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setExerciseState({ exercises: resp.data.results, refresh }));

    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.results;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeExerciseLoading(false));
  }
};

export const deleteExercise = async (id) => {
  try {
    // Set Loading
    dispatch(changeExerciseLoading(true));

    // API Fetching
    const resp = await httpClient().delete(
      ApiEndpoints.deleteExercise + "/" + id
    );
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(deleteExerciseState(id));
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeExerciseLoading(false));
  }
};

//for biometric exercise report

export const addBiometricExercise = async (formData) => {
  try {
    // Set Loading
    dispatch(changeExerciseLoading(true));

    // API Fetching
    const resp = await httpClient().post(
      ApiEndpoints.clientReport,
      {
        ...formData,
      }
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(addExerciseState(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeExerciseLoading(false));
  }
};
export const shareBiometricExerciseReport = async (formData) => {
  try {
    // Set Loading
    dispatch(changeExerciseLoading(true));

    // API Fetching
    const resp = await httpClient().post(
      ApiEndpoints.clientReport,
      {
        ...formData,
      }
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(addExerciseState(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeExerciseLoading(false));
  }
};


//for biometric exercise report
export const updateClientReportExerciseByReportId = async (
  biometricExerciseId,
  formData
) => {
  try {
    // Set Loading
    dispatch(changeExerciseLoading(true));

    // API Fetching
    const resp = await httpClient().patch(
      ApiEndpoints.clientReport +
        "/" +
        biometricExerciseId,
      {
        ...formData,
      }
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(updateExerciseState(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeExerciseLoading(false));
  }
};
